import { createApp } from "vue";
import "./assets/styles/index.scss";
import "./assets/icon/iconfont.css";
import "cesium/Build/Cesium/Widgets/widgets.css";

import "./assets/icon/iconfont";
import "./assets/font/iconfont";
import App from "./App.vue";
import { setupRouter } from "./router";
// 引入element-plus
import { setupElementPlus } from "@/plugins/elementPlus";
import "./permission";
// 全局组件
import { setupGlobCom } from "@/components";
import { createPinia } from "pinia";
import installPlugins from "@/plugins/global";

// 创建实例
const setupAll = () => {
  const app = createApp(App);
  const store = createPinia();
  app.use(store);
  setupRouter(app);
  setupGlobCom(app);
  setupElementPlus(app);
  installPlugins(app);
  app.mount("#app");
};
setupAll();
